import * as types from "../actions/actionTypes";
const INITIAL_DATA = {
  data: [],
  meta: {}
};
const initialState = {
  loading: true,
  error: "",
  ...INITIAL_DATA,

  removeProcessing: {},
  removedId: null
};

const File = (state = initialState, action) => {
  let removeProcessing = { ...state.removeProcessing };

  switch (action.type) {
    case types.GET_FILES_REQUEST:
      const filesData = action.pageNumber ? { ...action.data } : INITIAL_DATA; //todo fix
      return { ...state, loading: true, error: "" };
    case types.GET_FILES_SUCCESS:
      return { ...state, ...action.data, loading: false };
    case types.GET_FILES_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.REMOVE_FILE_REQUEST:
      removeProcessing[action.id] = true;
      return { ...state, removeProcessing: removeProcessing, removedId: null };
    case types.REMOVE_FILE_SUCCESS:
      removeProcessing[action.id] = false;
      return {
        ...state,
        removeProcessing: removeProcessing,
        removedId: action.id
      };
    case types.REMOVE_FILE_FAILURE:
      removeProcessing[action.id] = false;
      return { ...state, removeProcessing: removeProcessing };
    default:
      return state;
  }
};

export default File;
